import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { logOut } from '../../actions/loginAndRegisterActions';
import LinkButton from '../../components/LinkButton';
import PrimaryButton from '../../components/PrimaryButton';
import ViewWrapper, { FormWrapper } from '../../components/ViewWrapper';
import logo from '../../img/Airthings_Logo_Standard.png';
import styles from './LandingPage.module.scss';

const LandingPage = (): JSX.Element => {
    const { t: txt } = useTranslation();
    const dispatch = useDispatch();
    const onSubmit = (): void => {
        // do nothing
    };
    const onLogOut = (): void => {
        dispatch(logOut());
    };

    return (
        <ViewWrapper>
            <FormWrapper onSubmit={onSubmit} testAttr={'landing-page'}>
                <img src={logo} className={styles.logo} alt={txt('Logo.AirthingsLogo')} />
                <div className={styles.linkButton}>
                    <LinkButton link={'https://dashboard.airthings.com'} external label={'Login.GoToDashboard'} />
                </div>
                <PrimaryButton title={'Login.Logout'} onClick={onLogOut} />
            </FormWrapper>
        </ViewWrapper>
    );
};

export default LandingPage;
